import {
  makeMetricsPageLeave,
  makeMetricsPageLoad,
} from '../../Metrics/webPageDispatchers';

export const onPageArrive = ({
  action: {
    location: { kind },
  },
  dispatch,
  metrics,
  resetMetrics,
}) => {
  if (kind !== 'replace' && kind !== 'load') {
    dispatch(makeMetricsPageLoad({ metrics, resetMetrics }));
  }
};

export const onPageLeave = ({
  action: {
    location: { kind },
  },
  dispatch,
  metrics,
  saveMetric,
}) => {
  /* TODO does it make sense to have callbacks with { prev: true }
   * called on the initial load? */
  if (kind !== 'replace' && kind !== 'load') {
    dispatch(makeMetricsPageLeave({ metrics, saveMetric }));
  }
};
